import * as React from 'react';
import { useSelector } from 'react-redux';

import { IPinsLayer } from './usePinsLayer';
import { IApplicationState } from '../../../../common/types/redux';
import { selectDetailsVisiblePrecision, selectMapBounds } from '../../../selectors';
import { TMapBounds } from '../../../types/mapBounds';

export function usePinsDetailsVisibility({ pointsLayer, hotspotsLayer }: IPinsLayer): boolean {
  const detailsVisiblePrecision = useSelector(selectDetailsVisiblePrecision);
  const { precision } = useSelector<IApplicationState, TMapBounds>(selectMapBounds);

  const isDetailsVisible = precision >= detailsVisiblePrecision;

  React.useEffect(() => {
    pointsLayer.layer.update();
    hotspotsLayer.layer.update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDetailsVisible]);

  return isDetailsVisible;
}
